import { routes } from "routing";
import { lazyView, type RouteRender } from "routing/tree";

export const notificationsCalendarRoutes: RouteRender[] = [
  lazyView(
    routes.notificationsCalendar,
    () => import("./notifications-calendar").then((m) => ({ default: m.NotificationsCalendarPage })),
    "Notifications",
  ),
];
